
import { ControlFacet } from '../models/controls/ControlFacet';
import { ICommand } from '../models/commands/ICommand';

export const itemsContextMenuControl = new ControlFacet<{
  itemKey: string;
  itemSetKey?: string;
}, {
    commands: ICommand[];
  }>('itemsContextMenuControl');
